import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 5, max = 5, size = 16 }) => {
    return (
        <div
            className="inline-flex items-center gap-0.5"
            data-testid="star-rating"
            aria-label={`Note ${value} sur ${max}`}
        >
            {Array.from({ length: max }).map((_, i) => (
                <Star
                    key={i}
                    size={size}
                    className={
                        i < value
                            ? "fill-[#FFB300] text-[#FFB300]"
                            : "text-[#2A4A6B]"
                    }
                />
            ))}
        </div>
    );
};

export default StarRating;
